export default "__VITE_ASSET__dbc194e4__"